import { apply, call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchAccounts(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/ebayAccounts/list', {
    query: {
      page: payload.page,
    }
  });

  yield put({
    // $global: true,
    type: 'SET_EBAY_ACCOUNTS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}


export function* ebayImportListings(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.get, '/ebayListings/importListings', {
    query: {
      userId: payload.userId,
    }
  });

  const data = yield call(Http.get, '/ebayAccounts/list', {
    query: {
      page: payload.page,
    }
  });

  yield put({
    // $global: true,
    type: 'SET_EBAY_ACCOUNTS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* ebayImportTransactions(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.get, '/ebayListings/importTransactions', {
    query: {
      userId: payload.userId,
    }
  });

  const data = yield call(Http.get, '/ebayAccounts/list', {
    query: {
      page: payload.page,
    }
  });

  yield put({
    // $global: true,
    type: 'SET_EBAY_ACCOUNTS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* ebayAuthRedirect(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const { url } = yield call(Http.get, '/ebayAccounts/ebayAuthorizeUrl', {});
  location.href = url;
}

export default function*({ takeFirst }) {
  yield [
    takeFirst('EBAY_IMPORT_LISTINGS', ebayImportListings),
    takeFirst('EBAY_IMPORT_TRANSACTIONS', ebayImportTransactions),
    takeFirst('FETCH_EBAY_ACCOUNTS', fetchAccounts),
    takeFirst('EBAY_AUTH_REDIRECT', ebayAuthRedirect),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Accounts/Accounts.sagas.js